import { useI18n } from "@/i18n/I18nContext";

export const CHIPS = ["all", "app", "minisite"];
export const byCategory = (apps, cat) => apps && (cat === "all" ? apps : apps.filter((a) => (a.category || "app") === cat));

// « Tout / Applications / Mini-sites web » filter (official catalogue, other developers, developer pages).
export const CategoryChips = ({ apps, value, onChange, prefix }) => {
  const { t } = useI18n();
  if (!apps?.some((a) => a.category === "minisite")) return null;
  return (
    <div className="mb-6 flex flex-wrap gap-2" role="tablist" data-testid={`${prefix}-category-chips`}>
      {CHIPS.map((c) => (
        <button key={c} type="button" role="tab" aria-selected={value === c} onClick={() => onChange(c)}
          className={`max-w-full whitespace-normal break-words rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors ${value === c ? "border-[var(--gold)] bg-[var(--gold)] text-black" : "border-[rgba(245,197,66,0.3)] text-neutral-200 hover:border-[var(--gold)]"}`}
          data-testid={`${prefix}-chip-${c}`}>
          {t(`mini.chip.${c}`)}
        </button>
      ))}
    </div>
  );
};
